import { Box } from "@mui/material";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_contained")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Box sx={(theme) => ({ p: 4, maxWidth: theme.breakpoints.values.xl })}>
      <Outlet />
    </Box>
  );
}
